import React from "react";
import { Wallet, Coffee, LayoutGrid } from "lucide-react";
import Reveal from "../common/Reveal";

const CULTURE = [
  {
    icon: Wallet,
    title: "Financial Wellbeing",
    desc: "회사의 미래가치와 성과를 함께 나누고, 생활의 안정을 지원합니다.",
  },
  {
    icon: Coffee,
    title: "Time & Refresh",
    desc: "저마다 몰입할 수 있는 환경이 다름을 알기에 시간과 공간 선택의 자율성을 가지며, 리프레시를 위한 충전의 기회도 마련합니다.",
  },
  {
    icon: LayoutGrid,
    title: "Work Space",
    desc: "공간이 우리에게 미치는 영향을 잘 알기에, 우리가 일할 공간을 직접 설계합니다.",
  },
];

const Culture = () => {
  return (
    <section className="bg-primary-50/40 py-16">
      <div className="mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8">
        <Reveal>
          <span className="text-sm font-semibold uppercase tracking-wide text-accent-600">
            Culture
          </span>
          <h2 className="mt-3 break-keep text-3xl font-bold text-primary-900 sm:text-4xl">
            MTST의 문화
          </h2>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-3">
          {CULTURE.map(({ icon: Icon, title, desc }, index) => (
            <Reveal
              key={title}
              delay={index * 100}
              className="h-full rounded-xl border border-gray-100 bg-white p-8 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
            >
              <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-primary-800">
                <Icon className="h-7 w-7 text-white" strokeWidth={1.75} />
              </div>
              <h3 className="mt-5 text-xl font-bold text-primary-900">
                {title}
              </h3>
              <p className="mt-2 break-keep text-sm leading-relaxed text-gray-600">
                {desc}
              </p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Culture;
